import {FC, ReactNode, useRef} from 'react';
import {mergeProps, useFocusRing, useTableRow} from 'react-aria';
import {Node, TableState} from 'react-stately';
import TableStaticRow from 'components/Table/TableStatic/TableStaticRow';

type TableRowProps = {
    children: ReactNode;
    className?: string;
    item: Node<unknown>;
    state: TableState<unknown>;
};

const TableRow: FC<TableRowProps> = ({children, className, item, state}) => {
    const disabled = state.disabledKeys.has(item.key);
    const {props} = item;
    const ref = useRef(null);
    const {rowProps} = useTableRow(
        {
            node: item,
        },
        state,
        ref,
    );
    const {focusProps} = useFocusRing();

    return (
        <TableStaticRow
            {...mergeProps(rowProps, focusProps)}
            ref={ref}
            aria-disabled={disabled}
            className={className}
            {...props}
        >
            {children}
        </TableStaticRow>
    );
};

export default TableRow;
